(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["warpaint-clothing-rail"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('warpaint-clothing-rail')) {
  customElements.define('warpaint-clothing-rail', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.items = Array.from(this.querySelectorAll('.wp-rail__item'));
      if (!this.items.length) return;
      this.initialized = true;
      this.index = -1;
      this.viewport = this.querySelector('.wp-rail__viewport');
      this.dialog = this.querySelector('dialog');
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.abort = new AbortController();
      const on = (el, event, fn, opts = {}) => el.addEventListener(event, fn, { ...opts, signal: this.abort.signal });
      this.hookLayer = document.createElement('div');
      this.hookLayer.className = 'wp-rail__hooks';
      this.hookLayer.setAttribute('aria-hidden', 'true');
      this.hooks = this.items.map(item => {
        const hook = document.createElement('div');
        hook.className = 'wp-rail__hook-item';
        hook.append(item.querySelector('.wp-rail__hanger').cloneNode(true));
        this.hookLayer.append(hook);
        return hook;
      });
      this.viewport.append(this.hookLayer);
      this.classList.add('is-enhanced');
      this.items.forEach((item, index) => {
        const button = item.querySelector('button');
        button.disabled = false;
        on(button, 'pointerdown', () => { button.railWasSelected = this.index === index; });
        on(button, 'pointerenter', (event) => {
          if (event.pointerType === 'mouse' && window.matchMedia('(hover: hover)').matches) this.select(index);
        });
        on(button, 'focus', () => this.select(index));
        on(button, 'click', (event) => {
          if (Date.now() < (this.ignoreClickUntil || 0)) { event.preventDefault(); return; }
          const alreadySelected = event.detail > 0 ? button.railWasSelected : this.index === index;
          if (!alreadySelected) { this.select(index); return; }
          this.open(button);
        });
        on(button, 'keydown', (event) => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft' || event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            const target = event.key === 'Home' ? 0 : event.key === 'End' ? this.items.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + this.items.length) % this.items.length;
            this.select(target);
            this.items[target].querySelector('button').focus({ preventScroll: true });
          }
        });
      });
      on(this.querySelector('[data-prev]'), 'click', () => this.select((this.index < 0 ? this.items.length : this.index) - 1));
      on(this.querySelector('[data-next]'), 'click', () => this.select(this.index + 1));
      on(this.querySelector('[data-close]'), 'click', () => this.dialog.close());
      on(this.dialog, 'click', event => { if (event.target === this.dialog) { const r = this.dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dialog.close(); } });
      on(this.dialog, 'close', () => { if (this.returnFocus?.isConnected) this.returnFocus.focus({ preventScroll: true }); });
      on(this.querySelector('[data-flip]'), 'click', () => {
        this.showingFront = !this.showingFront;
        const item = this.items[this.index];
        const image = this.querySelector('[data-dialog-image] img');
        if (image) { image.src = this.showingFront ? item.dataset.front : item.dataset.back; image.removeAttribute('srcset'); }
        this.querySelector('[data-dialog-image]').classList.toggle('is-front', this.showingFront);
        this.querySelector('[data-flip]').textContent = this.showingFront ? this.dataset.backLabel : this.dataset.frontLabel;
      });
      on(this.viewport, 'pointerdown', event => { if (event.pointerType !== 'mouse') this.swipe = { x: event.clientX, y: event.clientY, id: event.pointerId }; });
      on(this.viewport, 'pointerup', event => {
        if (!this.swipe || this.swipe.id !== event.pointerId) return;
        const dx = event.clientX - this.swipe.x, dy = event.clientY - this.swipe.y;
        this.swipe = null;
        if (Math.abs(dx) > 36 && Math.abs(dx) > Math.abs(dy) * 1.3) {
          this.ignoreClickUntil = Date.now() + 400;
          this.select(this.index + (dx < 0 ? 1 : -1));
        }
      });
      on(this.viewport, 'pointercancel', () => { this.swipe = null; });
      this.observer = new ResizeObserver(() => this.position());
      this.observer.observe(this.viewport);
      this.querySelector('[data-prev]').disabled = this.items.length < 2;
      this.querySelector('[data-next]').disabled = this.items.length < 2;
      this.position();
      if (window.matchMedia('(hover: none), (max-width: 700px)').matches) this.select(0);
    }
    select(index) {
      this.index = (index + this.items.length) % this.items.length;
      const item = this.items[this.index];
      this.classList.add('has-selection');
      this.items.forEach((entry, i) => {
        entry.classList.toggle('is-selected', i === this.index);
        this.hooks[i].classList.toggle('is-selected', i === this.index);
        entry.querySelector('button').setAttribute('aria-pressed', String(i === this.index));
      });
      this.querySelector('[data-name]').textContent = item.dataset.title;
      this.querySelector('[data-selection-price]').textContent = item.dataset.price;
      this.querySelector('[data-selection-note]').hidden = item.dataset.illustrative !== 'true';
      this.querySelector('[data-count]').textContent = `${String(this.index + 1).padStart(2, '0')} / ${String(this.items.length).padStart(2, '0')}`;
      const shop = this.querySelector('[data-shop]');
      shop.href = item.dataset.url;
      shop.hidden = false;
      this.position();
    }
    position() {
      const width = this.viewport.clientWidth;
      const mobile = window.matchMedia('(max-width: 700px)').matches;
      const itemWidth = mobile ? 280 : 360;
      const step = Math.min(mobile ? 87 : 155, (width - (mobile ? 0 : 130)) / Math.max(this.items.length, 3));
      this.items.forEach((item, i) => {
        let x = (i - (this.items.length - 1) / 2) * step;
        if (this.index >= 0) {
          if (mobile) x = (i - this.index) * step + Math.sign(i - this.index) * 112;
          else x += Math.sign(i - this.index) * (itemWidth / 2 - step / 2 + 12);
        }
        const active = i === this.index;
        [item, this.hooks[i]].forEach(surface => {
          surface.style.setProperty('--rail-x', `${x}px`);
          surface.style.setProperty('--rail-turn', active ? '0deg' : '67deg');
          surface.style.setProperty('--rail-lean', active ? '0deg' : `${i % 2 === 0 ? -2 : 2}deg`);
          surface.style.setProperty('--rail-z', active ? 20 : this.items.length - i);
        });
      });
    }
    open(trigger) {
      if (this.index < 0) return;
      const item = this.items[this.index];
      if (typeof this.dialog.showModal !== 'function') { window.location.assign(item.dataset.url); return; }
      this.returnFocus = trigger;
      this.showingFront = false;
      this.querySelector('[data-dialog-title]').textContent = item.dataset.title;
      this.querySelector('[data-dialog-price]').textContent = item.dataset.price;
      this.querySelector('[data-dialog-note]').hidden = item.dataset.illustrative !== 'true';
      this.querySelector('[data-dialog-shop]').href = item.dataset.url;
      const source = item.querySelector('.wp-rail__garment');
      const imageHost = this.querySelector('[data-dialog-image]');
      imageHost.classList.toggle('is-mockup', item.dataset.illustrative === 'true');
      imageHost.classList.remove('is-front');
      imageHost.replaceChildren(...Array.from(source.childNodes, node => node.cloneNode(true)));
      const image = imageHost.querySelector('img');
      if (image && item.dataset.back) { image.removeAttribute('srcset'); image.removeAttribute('sizes'); image.src = item.dataset.back; image.loading = 'eager'; }
      const flip = this.querySelector('[data-flip]');
      flip.hidden = !item.dataset.front || item.dataset.front === item.dataset.back;
      flip.textContent = this.dataset.frontLabel;
      this.dialog.showModal();
      this.querySelector('[data-close]').focus();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.hookLayer?.remove();
      if (this.dialog?.open) this.dialog.close();
      this.initialized = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["warpaint-editorial-motion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('warpaint-editorial-motion')) {
  customElements.define('warpaint-editorial-motion', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.root = this.closest('[data-wp-motion-root]');
      if (!this.root || !('IntersectionObserver' in window)) return;
      this.initialized = true;
      this.abort = new AbortController();
      this.targets = Array.from(this.root.querySelectorAll('[data-wp-motion]')).filter(target => !target.closest('warpaint-clothing-rail'));
      this.preference = window.matchMedia('(prefers-reduced-motion: reduce)');
      const options = { signal: this.abort.signal };
      this.targets.forEach(target => {
        target.addEventListener('animationend', event => {
          if (event.target === target) target.classList.remove('wp-motion-enter');
        }, options);
        target.addEventListener('focusin', () => this.finish(target), options);
        const image = this.imageFor(target);
        if (image && !image.complete) {
          image.addEventListener('load', () => {
            if (this.preference.matches || target.dataset.wpMotionPlayed) return;
            const bounds = target.getBoundingClientRect();
            if (bounds.bottom > 0 && bounds.top < window.innerHeight) this.enter(target);
          }, { ...options, once: true });
        }
      });
      this.preference.addEventListener('change', () => this.configure(), options);
      this.configure();
    }
    configure() {
      this.observer?.disconnect();
      this.targets.forEach(target => target.classList.remove('wp-motion-enter'));
      if (this.preference.matches) return;
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) this.enter(entry.target);
        });
      }, { threshold: .12 });
      this.targets.filter(target => !target.dataset.wpMotionPlayed).forEach(target => this.observer.observe(target));
    }
    imageFor(target) {
      if (!target.dataset.wpMotion.includes('photo')) return null;
      return target.tagName === 'IMG' ? target : target.querySelector('img');
    }
    enter(target) {
      if (this.preference.matches || target.dataset.wpMotionPlayed || !target.isConnected) return;
      const image = this.imageFor(target);
      if (image && (!image.complete || !image.naturalWidth)) return;
      if (target.contains(document.activeElement)) { this.finish(target); return; }
      target.dataset.wpMotionPlayed = 'true';
      target.classList.add('wp-motion-enter');
      this.observer?.unobserve(target);
    }
    finish(target) {
      target.dataset.wpMotionPlayed = 'true';
      target.classList.remove('wp-motion-enter');
      this.observer?.unobserve(target);
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.targets?.forEach(target => target.classList.remove('wp-motion-enter'));
      this.initialized = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["warpaint-field-style"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('warpaint-field-notes')) {
  customElements.define('warpaint-field-notes', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.root = this.closest('.wp-field');
      if (!this.root || !this.root.hasAttribute('data-field-motion')) return;
      this.initialized = true;
      this.abort = new AbortController();
      this.scenes = Array.from(this.root.querySelectorAll('[data-field-scene]'));
      this.preference = matchMedia('(prefers-reduced-motion: reduce)');
      this.schedule = () => {
        if (!this.enabled || this.frame || document.hidden) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          if (!this.enabled) return;
          const height = window.innerHeight;
          const values = this.scenes.map(scene => {
            const rect = scene.getBoundingClientRect();
            return { scene, value: Math.max(0, Math.min(1, (height - rect.top) / (height + rect.height))) };
          });
          values.forEach(({ scene, value }) => scene.style.setProperty('--field-progress', value.toFixed(4)));
        });
      };
      const options = { signal: this.abort.signal };
      document.addEventListener('scroll', this.schedule, { ...options, passive: true, capture: true });
      window.addEventListener('resize', this.schedule, { ...options, passive: true });
      document.addEventListener('visibilitychange', this.schedule, options);
      this.preference.addEventListener('change', () => this.configure(), options);
      this.configure();
    }
    configure() {
      this.enabled = !this.preference.matches;
      this.root.toggleAttribute('data-field-active', this.enabled);
      if (!this.enabled) { cancelAnimationFrame(this.frame); this.frame = 0; }
      else this.schedule();
    }
    disconnectedCallback() {
      this.abort?.abort();
      cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.root?.removeAttribute('data-field-active');
      this.scenes?.forEach(scene => scene.style.removeProperty('--field-progress'));
      this.initialized = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
